let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jGp3x")).then(() => parcelRequire('hhLZ2'));